"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyRolePermissionsOnFeature = exports.maybe = exports.getRolePermissions = exports.extractUserRole = exports.emptyObject = void 0;
var _this = void 0;
var emptyObject = exports.emptyObject = Object.create(null);
/**
 * Capitalizes a given text stream.
 *
 * @param {*} text the text (role) to capitalize
 */
var capitalize = function capitalize(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
};
var getEventRole = function getEventRole(event) {
  if (event) {
    // this has been added to make cypress pass.
    return capitalize(event.role || 'readOnly');
  }
  return '';
};
var extractRolePermissions = function extractRolePermissions() {
  var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var permissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var role = getEventRole(event);
  if (role) {
    var rolePerms = permissions.RolePermissions[role];
    return rolePerms ? rolePerms.permissions.filter(function (perm) {
      return perm;
    }) : [];
  }
  return [];
};

/**
 * Extracts the permissions assigned to the current role.
 *
 * @param {Object} event - The current user event.
 * @param {Array} permissions  - The permissions to filter on.
 */
var getRolePermissions = exports.getRolePermissions = function getRolePermissions(event, permissions) {
  var rolePermissions = extractRolePermissions(event, permissions);
  return function (permission) {
    return rolePermissions.filter(function (rperm) {
      return rperm.key === permission;
    }).length === 1;
  };
};

/**
 * Verifies a given permission set against the current event role..
 *
 * @param {Object} event - The current user event.
 * @param {Array} viewPermissions - permission list to verify.
 */
var verifyRolePermissionsOnFeature = exports.verifyRolePermissionsOnFeature = function verifyRolePermissionsOnFeature(event, viewPermissions) {
  if (event && viewPermissions) return getRolePermissions(event, viewPermissions);
  return function () {
    return false;
  };
};

/**
 * Extracts the role assigned to the current user.
 *
 * @param {Object} events - The current user events.
 * @param {string} eventId - the current event id.
 */
var extractUserRole = exports.extractUserRole = function extractUserRole(user, eventId) {
  var currentEvent = null;
  if (user && user.events && eventId) {
    currentEvent = user.events.filter(function (evt) {
      return evt.event === eventId;
    })[0];
  }
  return getEventRole(currentEvent);
};

/**
 * A function decorator that ensures that all arguments passed
 * to a close function a valid before executing. Incase one of the required
 * arguments is not valid (null || undefined), an empty object is returned as a result.
 *
 * Note that a parameter-less function will execute as expected.
 *
 * @param {function} fn - the function to execute against the arguments.
 */
var maybe = exports.maybe = function maybe(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 0) {
      return fn.apply(_this, []);
    } else {
      var hasInvalidArgs = args.some(function (arg) {
        return !arg;
      });
      if (hasInvalidArgs) {
        return Object.create(null);
      }
      return fn.apply(_this, args);
    }
  };
};